/* eslint-disable no-undef */
import { REDUX_CONSTANT } from '../../constants';
import { JSON_HEADER, AUTH_HEADER } from '../../config';
import config from '../../config.json';
import * as TYPES from '../types';
import { createEndpoint } from './../../helpers/commonHelper';

const util = require('util');

export const onLoad = () => ({
    type: TYPES.ON_LOAD,
    payload: {
        isLoading: false
    }
});

export const updateSubscriberData = (vendorId, student) => ({
    type: TYPES.APIREQUEST,
    payload: {
        onload: onLoad,
        endpoint: `${createEndpoint(
            REDUX_CONSTANT.services.vendorService
        )}${util.format(
            config.REACT_APP_STUDENTS_EDIT_URL,
            vendorId,
            student.studentCoachingId
        )}`,
        method: 'PATCH',
        body: JSON.stringify(student),
        onsuccess: onUpdateStudentSuccess,
        onerror: onfail,
        title: REDUX_CONSTANT.UPDATE_SUBSCRIBER_DATA
    }
});

export const onUpdateStudentSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.UPDATE_SUBSCRIBER_DATA
    };
};

function getPaginationEndpointURL(
    isAdmin,
    vendorId,
    redemptionStatus,
    searchText,
    sortFieldForVendor,
    sortOrderForVendor,
    subscriptionType,
    linkStatus,
    pageNumber,
    pageSize,
    sortTypeForAdmin
) {
    let endpoint = '';
    if (isAdmin) {
        let baseURL = `${createEndpoint(
            REDUX_CONSTANT.services.configurationService
        )}`;
        endpoint =
            baseURL +
            util.format(
                config.REACT_APP_GET_STUDENT_ADMIN_RECORDS_URL,
                sortTypeForAdmin,
                pageNumber,
                pageSize
            );
    } else {
        let baseURL = `${createEndpoint(
            REDUX_CONSTANT.services.vendorService
        )}`;
        endpoint =
            baseURL +
            util.format(
                config.REACT_APP_GET_STUDENT_RECORDS_URL,
                vendorId,
                sortOrderForVendor,
                pageNumber,
                pageSize
            );
    }
    if (
        redemptionStatus &&
        redemptionStatus.length > 0 &&
        redemptionStatus !== 'All'
    ) {
        endpoint = endpoint + `&RedemptionStatus=${redemptionStatus}`;
    }

    if (searchText && searchText.length > 0) {
        endpoint = endpoint + `&SearchText=${searchText}`;
    }
    if (sortFieldForVendor && sortFieldForVendor.length > 0) {
        endpoint = endpoint + `&SortField=${sortFieldForVendor}`;
    }
    if (
        subscriptionType &&
        subscriptionType.length > 0 &&
        subscriptionType !== 'All'
    ) {
        endpoint = endpoint + `&SubscriptionType=${subscriptionType}`;
    }

    if (linkStatus && linkStatus.length > 0 && linkStatus !== 'All') {
        endpoint = endpoint + `&linkStatus=${linkStatus}`;
    }

    return endpoint;
}

export const getFilteredVendorInformation = (
    vendorId,
    redemptionStatus,
    searchText,
    sortFieldForVendor,
    sortOrderForVendor,
    subscriptionType,
    linkStatus,
    pageNumber,
    pageSize
) => {
    let endPoint = `${getPaginationEndpointURL(
        false,
        vendorId,
        redemptionStatus,
        searchText,
        sortFieldForVendor,
        sortOrderForVendor,
        subscriptionType,
        linkStatus,
        pageNumber,
        pageSize,
        null
    )}`;

    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: endPoint,
            method: 'GET',
            onsuccess: onVendorStudentSuccess,
            onerror: onfail,
            title: REDUX_CONSTANT.GET_SUBSCRIBER_DATA
        }
    };
};

export const onVendorStudentSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.GET_SUBSCRIBER_DATA
    };
};

export const onfail = (msg, title = '') => ({
    type: TYPES.ERROR,
    payload: { msg, title }
});

export const addStudentData = (vendorId, studentData) => {
    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.vendorService
            )}${util.format(config.REACT_APP_STUDENTS_URL, vendorId)}`,
            method: 'POST',
            body: JSON.stringify(studentData),
            onsuccess: onAddStudentSuccess,
            onerror: onfail,
            title: REDUX_CONSTANT.ADD_SUBSCRIBER_DATA
        }
    };
};

export const addFeeWaiverStudentData = (vendorId, student) => {
    let body = {
        emailAddress: student.email,
        firstName: student.first_name,
        lastName: student.last_name
    };

    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.vendorService
            )}${util.format(
                config.REACT_APP_FEE_WAIVER_STUDENTS_URL,
                vendorId
            )}`,
            method: 'POST',
            body: JSON.stringify(body),
            onsuccess: onAddStudentSuccess,
            onerror: onfail,
            title: REDUX_CONSTANT.ADD_SUBSCRIBER_DATA
        }
    };
};

export const addPlusProgramStudentData = (
    vendorId,
    student,
    coachingProductIds
) => {
    let body = {
        firstName: student.first_name,
        lastName: student.last_name,
        emailAddress: student.email,
        coachingProductIds: coachingProductIds
    };

    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.vendorService
            )}${util.format(
                config.REACT_APP_PLUS_PROGRAM_STUDENTS_URL,
                vendorId
            )}`,
            method: 'POST',
            body: JSON.stringify(body),
            onsuccess: onAddStudentSuccess,
            onerror: onfail,
            title: REDUX_CONSTANT.ADD_SUBSCRIBER_DATA
        }
    };
};

export const onAddStudentSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.ADD_SUBSCRIBER_DATA
    };
};
export const getStudentVendorOrder = (
    vendorId,
    studentId,
    SortField,
    sortOrder,
    pageNo,
    pageSize
) => {
    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.vendorService
            )}${util.format(
                config.REACT_APP_GET_STUDENT_VENDOR_ORDER,
                vendorId,
                studentId,
                SortField,
                sortOrder,
                pageNo,
                pageSize
            )}`,
            method: 'GET',
            onsuccess: onGetStudentVendorOrderSuccess,
            onerror: onfail,
            title: REDUX_CONSTANT.GET_STUDENT_VENDOR_ORDER
        }
    };
};

export const onGetStudentVendorOrderSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.GET_STUDENT_VENDOR_ORDER
    };
};

export const resendInvitation = (vendorId, cochId) => {
    let body = {
        studentCoachingId: cochId
    };

    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.vendorService
            )}${util.format(config.REACT_APP_RESEND_INVITATION_URL, vendorId)}`,
            method: 'POST',
            body: JSON.stringify(body),
            onsuccess: onResendInvitationSuccess,
            onerror: onfail,
            title: REDUX_CONSTANT.RESEND_INVITATION_DATA
        }
    };
};

export const onResendInvitationSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.RESEND_INVITATION_DATA
    };
};

export const refundStudent = (vendorId, cochId) => {
    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.configurationService
            )}${util.format(config.REACT_APP_REFUND_URL, vendorId, cochId)}`,
            method: 'POST',
            onsuccess: onRefundStudentSuccess,
            onerror: onfail
        }
    };
};

export const onRefundStudentSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.REFUND_STUDENT_DATA
    };
};

export const getAllVendors = () => ({
    type: TYPES.APIREQUEST,
    payload: {
        onload: onLoad,
        endpoint: `${createEndpoint(
            REDUX_CONSTANT.services.configurationService
        )}${util.format(config.REACT_APP_GET_ALL_VENDOR_URL)}`,
        method: 'GET',
        onsuccess: onGetAllVendorsSuccess,
        onerror: onfail,
        title: REDUX_CONSTANT.GET_ALL_VENDORS_DATA
    }
});

export const onGetAllVendorsSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.GET_ALL_VENDORS_DATA
    };
};

export const updateAllVendorsData = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.REMOVE_ALL_VENDORS_DATA
    };
};

export const getStudentDetails = (vendorId, studentId) => ({
    type: TYPES.APIREQUEST,
    payload: {
        onload: onLoad,
        endpoint: `${createEndpoint(
            REDUX_CONSTANT.services.vendorService
        )}${util.format(
            config.REACT_APP_GET_STUDENT_DETAILS_URL,
            vendorId,
            studentId
        )}`,
        method: 'GET',
        onsuccess: onGetStudentDetailsSuccess,
        onerror: onfail
    }
});

export const onGetStudentDetailsSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.SET_SELECTED_STUDENT_ITEM
    };
};

export const getTestHistoryForStudent = (
    vendorId,
    studentId,
    fromDate,
    toDate,
    pageNumber,
    testFilterValue,
    fetchNew
) => ({
    type: TYPES.APIREQUEST,
    payload: {
        onload: onLoad,
        endpoint: `${createEndpoint(
            REDUX_CONSTANT.services.vendorService
        )}${getTestHistoryEndpointURL(
            vendorId,
            studentId,
            fromDate,
            toDate,
            pageNumber,
            testFilterValue,
            100
        )}`,
        method: 'GET',
        onsuccess: fetchNew
            ? onGetStudentNewTestHistorySuccess
            : onGetStudentMoreTestHistorySuccess,
        onerror: onfail,
        title: REDUX_CONSTANT.GET_STUDENT_TEST_HISTORY_NEW
    }
});

export const onGetStudentNewTestHistorySuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.GET_STUDENT_TEST_HISTORY_NEW
    };
};

export const onGetStudentMoreTestHistorySuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.GET_STUDENT_TEST_HISTORY_MORE
    };
};

export const uploadFile = (file) => {
    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.configurationService
            )}${util.format(config.REACT_APP_BULK_UPLOAD_URL)}`,
            method: 'POST',
            body: JSON.stringify(file),
            onsuccess: onUploadFileSuccess,
            onerror: onUploadFileFail
        }
    };
};

export const onUploadFileSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.BULK_UPLOAD_STUDENT_DATA
    };
};

export const onUploadFileFail = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.BULK_UPLOAD_STUDENT_FAIL
    };
};

export const uploadedStatus = (vendorId) => {
    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.configurationService
            )}${util.format(
                config.REACT_APP_BULK_UPLOAD_STATUS_URL,
                vendorId
            )}`,
            method: 'GET',
            onsuccess: onUploadedStatusSuccess,
            onerror: onfail
        }
    };
};

export const onUploadedStatusSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.BULK_UPLOAD_STATUS
    };
};

export const getProcessedRecords = (vendorId, fileId) => {
    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.configurationService
            )}${util.format(
                config.REACT_APP_BULK_UPLOAD_PROCESSED_URL,
                vendorId,
                fileId
            )}`,
            method: 'GET',
            onsuccess: onProcessedRecordsSuccess,
            onerror: onfail
        }
    };
};

export const onProcessedRecordsSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.BULK_UPLOAD_PROCESSED
    };
};

export const upgradeStudentSubscription = (vendorId, coachId) => {
    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.vendorService
            )}${util.format(
                config.REACT_APP_UPGRADE_SUBSCRIPTION_URL,
                vendorId,
                coachId
            )}`,
            method: 'POST',
            onsuccess: upgradeStudentSubscriptionSuccess,
            onerror: onfail
        }
    };
};

export const upgradeStudentSubscriptionSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.UPGRADE_STUDENT_SUBSCRIPTION_DATA
    };
};

export const getTestResults = (vendorId, studentId, testId) => {
    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.vendorService
            )}${util.format(
                config.REACT_APP_TEST_RESULT_URL,
                vendorId,
                studentId,
                testId
            )}`,
            method: 'GET',
            onsuccess: onGetTestResultSuccess,
            onerror: onfail
        }
    };
};

export const onGetTestResultSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.TEST_RESULT_PROCESSED
    };
};

export const resetStudentDetails = () => {
    return {
        type: REDUX_CONSTANT.STUDENT_DETAIL_RESET
    };
};

export const getTestResultPDF = (vendorId, studentId, testId) => {
    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.vendorService
            )}${util.format(
                config.REACT_APP_TEST_RESULT_PDF_URL,
                vendorId,
                studentId,
                testId
            )}`,
            method: 'GET',
            onsuccess: onGetTestResultPDFSuccess,
            onerror: onfail
        }
    };
};

export const onGetTestResultPDFSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.TEST_RESULT_PDF
    };
};

export const filterStudentsForLsac = (value) => {
    return {
        payload: value,
        type: REDUX_CONSTANT.FILTER_SUBSCRIBER_DATA_FOR_LSAC
    };
};

export const filterStudentsForPrep = (value) => {
    return {
        payload: value,
        type: REDUX_CONSTANT.FILTER_SUBSCRIBER_DATA_FOR_PREP
    };
};

export const searchStudents = (value) => {
    return {
        payload: value,
        type: REDUX_CONSTANT.SEARCH_SUBSCRIBER_DATA
    };
};

export const updateAddSubscriberByDefault = (value) => {
    return {
        payload: value,
        type: REDUX_CONSTANT.UPDATE_ADD_SUBSCRIBER_BY_DEFAULT
    };
};

export const updateResendInviteByDefault = (value) => {
    return {
        payload: value,
        type: REDUX_CONSTANT.UPDATE_RESEND_INVITE_BY_DEFAULT
    };
};

export const updateAddStudentConfirmationByDefault = (value) => {
    return {
        payload: value,
        type: REDUX_CONSTANT.UPDATE_ADD_STUDENT_CONFIRMATION_BY_DEFAULT
    };
};

export const setSelectedSubscriber = (student) => {
    return {
        payload: student,
        type: REDUX_CONSTANT.SET_SELECTED_STUDENT_ITEM
    };
};

export const setResendInviteFlag = (flag) => {
    return {
        payload: flag,
        type: REDUX_CONSTANT.SET_RESEND_INVITE_FLAG
    };
};

export const resetTestResult = () => {
    return {
        type: REDUX_CONSTANT.TEST_RESULT_RESET
    };
};

function getTestHistoryEndpointURL(
    vendorId,
    studentId,
    fromDate,
    toDate,
    pageNumber,
    testFilterValue,
    pageSize
) {
    let endpoint = util.format(
        config.REACT_APP_GET_STUDENT_TEST_HISTORY_URL,
        vendorId,
        studentId,
        pageNumber,
        pageSize
    );
    if (fromDate && fromDate.length > 0 && toDate && toDate.length > 0) {
        endpoint = endpoint + `&FromDate=${fromDate}` + `&ToDate=${toDate}`;
    }
    if (
        config.REACT_APP_TEST_HISTORY_FILTER_FEATURE === 'true' &&
        testFilterValue &&
        testFilterValue.length > 0
    ) {
        endpoint =
            endpoint +
            `&IsComplete=${
                testFilterValue === 'All Prep Test'
                    ? 'All'
                    : testFilterValue === 'Completed Prep Test'
                      ? 'yes'
                      : 'no'
            }`;
    }

    return endpoint;
}

export const onRenewStudentSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.RENEW_STUDENT_DATA
    };
};

export const renewStudentData = (vendorId, coachingProductIds, student) => {
    let body = {
        studentCoachingId: student.studentCoachingId,
        emailAddress: student.emailAddress,
        coachingProductIds: coachingProductIds,
        firstName: student.firstName,
        lastName: student.lastName
    };

    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.vendorService
            )}${util.format(config.REACT_APP_RENEW_STUDENT_URL, vendorId)}`,
            method: 'POST',
            body: JSON.stringify(body),
            onsuccess: onRenewStudentSuccess,
            onerror: onfail,
            title: REDUX_CONSTANT.RENEW_STUDENT_DATA
        }
    };
};

export const updateIsLoading = (value) => {
    return {
        payload: value,
        type: REDUX_CONSTANT.ISLOADING
    };
};

export const refundVendorOrder = (vendorId, cochId, orderId) => {
    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.configurationService
            )}${util.format(
                config.REACT_APP_VENDOR_REFUND_ORDER,
                vendorId,
                cochId,
                orderId
            )}`,
            method: 'POST',
            onsuccess: refundVendorOrderSuccess,
            onerror: onfail,
            title: REDUX_CONSTANT.GET_VENDOR_REFUND_DATA
        }
    };
};

export const refundVendorOrderSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.GET_VENDOR_REFUND_DATA
    };
};

export const refundVendorProductOrder = (
    vendorId,
    cochId,
    orderId,
    productId
) => {
    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.configurationService
            )}${util.format(
                config.REACT_APP_VENDOR_REFUND_PRODUCT_ORDER,
                vendorId,
                cochId,
                orderId,
                productId
            )}`,
            method: 'POST',
            onsuccess: refundVendorProductOrderSuccess,
            onerror: onfail,
            title: REDUX_CONSTANT.GET_VENDOR_REFUND_PRODUCT_DATA
        }
    };
};

export const refundVendorProductOrderSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.GET_VENDOR_REFUND_PRODUCT_DATA
    };
};

export const searchAdminSubscriberSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.GET_ADMIN_SUBSCRIBER_DATA
    };
};

export const refreshSubscription = (vendorId, cochId) => {
    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.configurationService
            )}${util.format(
                config.REACT_APP_REFRESH_SUBSCRIPTION_URL,
                vendorId,
                cochId
            )}`,
            method: 'PUT',
            onsuccess: refreshSubscriptionSuccess,
            onerror: onfail,
            title: REDUX_CONSTANT.GET_REFRESH_SUBSCRIPTION_DATA
        }
    };
};
export const refreshSubscriptionSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.GET_REFRESH_SUBSCRIPTION_DATA
    };
};

export const clearAllSearchBoxesForAdmin = () => {
    return {
        type: REDUX_CONSTANT.ADMIN_STUDENT_SEARCH_RESET
    };
};

export const resetSubscriberHomePageData = () => {
    return {
        type: REDUX_CONSTANT.SUBSCRIBER_HOME_PAGE_RESET
    };
};
